import { CHAT_CHANNEL, ORIGIN_DEFAULT, VENDOR_NAME_CARVANA } from 'constants/global';
import { IDENTIFY_TYPE, IDENTIFY_TYPES } from 'constants/id';
import { avatarAuthenticateAsync } from 'services/chatBackend';
import { StartConversationRequest } from 'services/chatBackend/startConversation';
import { executeCommand } from 'services/chatBackend/commands';
import {
  PropelAuthForTwilioClientResponseType,
  PropelMojoAuthResponseType,
} from 'services/propel/types';
import { UserType } from 'utils/chatContext/types';

import { expired } from 'utils/token';

/**
 * Helper function for calling Chat BE's avatarAuthneticate endpoint
 * @param propelMojoAuth
 * @returns
 */
const fetchTwilioClientAuthAsync = async (
  propelMojoAuth: PropelMojoAuthResponseType,
): Promise<PropelAuthForTwilioClientResponseType> => {
  const {
    data: { twilioAccessToken },
  } = await avatarAuthenticateAsync(
    {
      conversationId: propelMojoAuth.conversation_id,
    },
    propelMojoAuth.access_token,
  );
  return { access_token: twilioAccessToken };
};

const getStartConversationRequest = (
  browserCookieId: string | undefined | null,
  carvanaDeviceId: string | undefined | null,
  user: UserType | undefined | null,
  userIdentifierType: IDENTIFY_TYPE | undefined,
): StartConversationRequest => {
  const commonProps: any = {
    userProfileId: user?.user_id || browserCookieId || carvanaDeviceId,
    channel: CHAT_CHANNEL,
    origin: {
      vendorId: ORIGIN_DEFAULT, // FIXME - may need updating
      vendorName: VENDOR_NAME_CARVANA,
      meta: {},
    },
  };
  const userProps: any = {};
  if (user) {
    const { email, family_name, given_name } = user;

    if (email) userProps.email = email;
    if (given_name) userProps.firstName = given_name;
    if (family_name) userProps.lastName = family_name;
  }

  if (userIdentifierType === IDENTIFY_TYPES.BROWSER_COOKIE_ID) {
    return {
      ...commonProps,
      ...userProps,
      browserCookieId: browserCookieId,
      carvanaBrowserCookieId: browserCookieId,
      userInfo: { browser_cookie_id: browserCookieId, carvana_browser_cookie_id: browserCookieId }, // these props are intentionally left as snake_case
    };
  }

  return {
    ...commonProps,
    ...userProps,
    carvana_device_id: carvanaDeviceId,
    user_info: { carvana_device_id: carvanaDeviceId },
  };
};

const getStartConversationHeaders = (idToken: string | null, refreshToken: string | null) => {
  if (idToken && !expired(idToken)) {
    return { Authorization: `Bearer ${idToken}` };
  }

  if (!idToken && refreshToken && !expired(refreshToken)) {
    return { Authorization: `Bearer ${refreshToken}` };
  }

  return {};
};
export default {
  fetchTwilioClientAuthAsync,
  getStartConversationRequest,
  getStartConversationHeaders,
  executeCommand,
};
